import { Permission } from '~core/models/roles.models';
import { ROUTES } from './routes.constants';

export const SIDEBAR_LINKS: Array<{
  id: string;
  label: string;
  url: string;
  tooltip?: string;
  icon: string;
  hasBadge?: boolean;
  exactActive?: boolean;
  sectionTitle?: string;
  permissions?: Permission[];
  enabled?: boolean;
}> = [
  {
    id: 'dashboard',
    label: 'Tableau de bord',
    icon: 'discover',
    url: '/',
    exactActive: true,
    sectionTitle: 'Général',
    tooltip:
      'Suivez vos principaux indicateurs de facturation (factures, reçus, taxes, stickers) sur la période sélectionnée'
  },
  /*
  {
    id: 'invoice',
    label: 'Gestion des factures',
    icon: 'file-validation-stroke-rounded',
    url: '/invoices',
    sectionTitle: 'Gestion des factures & reçus',
    permissions: [Permission.READ_INVOICE],
    tooltip:
      'Consultez et gérez vos factures émises et réceptionnées (statuts, téléchargements, historique)'
  },
  {
    id: 'paymentReceipt',
    label: 'Gestion des reçus',
    icon: 'invoice-03-stroke-rounded',
    url: '/payment-receipts',
    permissions: [Permission.READ_RECEIPT],
    tooltip:
      'Consultez et gérez vos reçus émis et reçus (statuts, téléchargements, historique)'
  },
  */
  {
    id: 'organizationManagement',
    label: 'Toutes les entreprises',
    icon: 'building-04-stroke-rounded',
    url: '/organizations',
    hasBadge: true,
    sectionTitle: 'Organisations & Opérations',
    permissions: [Permission.READ_ORGANIZATION],
    tooltip:
      'Gérez vos établissements et points de vente rattachés à votre compte FNE'
  },
  {
    id: 'invoice',
    label: 'Gestion des factures',
    icon: 'file-validation-stroke-rounded',
    url: '/invoices',
    permissions: [Permission.READ_INVOICE],
    tooltip:
      'Consultez et gérez vos factures émises et réceptionnées (statuts, téléchargements, historique)'
  },
  {
    id: 'paymentReceipt',
    label: 'Gestion des reçus',
    icon: 'invoice-03-stroke-rounded',
    url: '/payment-receipts',
    permissions: [Permission.READ_RECEIPT],
    tooltip:
      'Consultez et gérez vos reçus émis et reçus (statuts, téléchargements, historique)'
  },
  {
    id: 'sticker',
    label: 'Gestion de stickers',
    icon: 'qr-code-01-stroke-rounded',
    url: '/stickers',
    hasBadge: true,
    sectionTitle: 'Stickers',
    permissions: [Permission.READ_STICKER],
    tooltip:
      'Consultez votre solde, l’historique et rechargez votre solde de stickers'
  },
  {
    id: 'invoice',
    label: 'Paiements & transactions',
    icon: 'money-receive-01-stroke-rounded',
    url: '/payments',
    permissions: [Permission.READ_PAYMENT],
    tooltip:
      'Consultez l’historique de vos paiements et transactions liés à la facturation'
  },
  {
    id: 'tax',
    label: 'Paramétrage des taxes',
    icon: 'tag-02-stroke-rounded',
    url: '/taxes',
    hasBadge: false,
    sectionTitle: 'Paramètres & Règles',
    permissions: [Permission.READ_TAX],
    tooltip:
      'Paramétrez les taux de TVA et autres taxes applicables à vos factures'
  },
  {
    id: 'taxType',
    label: 'Gestion des types de taxes',
    icon: 'tag-02-stroke-rounded',
    url: '/tax-types',
    hasBadge: false,
    permissions: [Permission.READ_TAX_TYPE],
    tooltip:
      ' Paramétrez les types de taxes (TVA, IS, IR, etc.) applicables à vos factures'
  },
  {
    id: 'taxProfile',
    label: 'Gestion des profils fiscaux',
    icon: 'user-list-stroke-rounded',
    url: '/tax-profiles',
    permissions: [Permission.READ_TAX_PROFILE],
    tooltip: 'Consultez les profils fiscaux configurés'
  },
  {
    id: 'equipmentManagement',
    label: 'Equipements de facturation',
    icon: 'ai-phone-02-stroke-rounded',
    url: '/billing-equipments',
    hasBadge: true,
    permissions: [Permission.READ_REFERENCE_DATA],
    tooltip:
      'Gérez vos équipements de certification électronique (imprimantes, logiciels, caisses)'
  },
  {
    id: 'currency',
    label: 'Gestion des devises',
    icon: 'money-bag-02-stroke-rounded',
    url: '/currencies',
    hasBadge: false,
    permissions: [Permission.READ_CURRENCY],
    tooltip: 'Gérez les devises utilisables dans vos documents de facturation'
  },
  {
    id: 'unitMeasure',
    label: 'Unités de mesure',
    icon: 'tape-measure',
    url: '/unite-mesures',
    hasBadge: false,
    permissions: [Permission.READ_UNIT_MEASURE],
    tooltip:
      'Paramétrez les unités de mesure utilisées pour votre facturation (pièce, kg, litre…)'
  },
  {
    id: 'users',
    label: 'Gestion des utilisateurs',
    icon: 'account-setting',
    url: ROUTES.users,
    hasBadge: false,
    sectionTitle: 'Compte & Sécurité',
    permissions: [Permission.READ_DGI_ADMIN],
    tooltip:
      'Créez des utilisateurs, attribuez des rôles et gérez les habilitations'
  },
  // {
  //   id: 'notifications',
  //   label: 'Système de notifications',
  //   icon: 'notification-02-stroke-rounded',
  //   url: '/notifications',
  //   hasBadge: false,
  //   enabled: false,
  //   permissions: [Permission.READ_NOTIFICATION],
  //   tooltip:
  //     'Gérez les règles et canaux de notification des événements de la plateforme'
  // },
  {
    id: 'dgi-settings',
    label: 'Paramètres DGI',
    icon: 'ai-setting-stroke-rounded',
    url: '/dgi-settings/dashboards',
    permissions: [
      Permission.READ_DGI_DASHBOARD_CONFIG,
      Permission.READ_DGI_SECURITY_CONFIG
    ],
    hasBadge: false,
    tooltip:
      'Configurez les tableaux de bord et règles métier spécifiques à la DGI'
  },
  // {
  //   id: 'security',
  //   label: 'Sécurité & contrôle d’accès',
  //   icon: 'locked-stroke-rounded',
  //   url: '/security',
  //   hasBadge: true
  // },
  {
    id: 'auditLog',
    label: 'Audit Logs',
    icon: 'bug',
    url: ROUTES.auditLogs,
    hasBadge: false,
    permissions: [Permission.READ_AUDIT_LOG],
    tooltip:
      'Consultez le journal d’audit retraçant les actions réalisées sur votre compte'
  }

  // {
  //   id: 'invoices',
  //   label: 'Mes factures',
  //   icon: 'file-validation',
  //   url: ROUTES.invoices,
  //   hasBadge: true,
  //   sectionTitle: 'Ventes & achats'
  // },
  // {
  //   id: 'favourite',
  //   label: "Note d'avoirs 3R",
  //   icon: 'money-receive',
  //   url: '/asset-management',
  //   hasBadge: true
  // },
  // {
  //   id: 'customerSupplier',
  //   label: 'Partenaires',
  //   icon: 'user-group',
  //   url: '/customer-supplier',
  //   hasBadge: true
  // },
  // {
  //   id: 'product',
  //   label: 'Gestion des articles',
  //   icon: 'store',
  //   url: '/articles',
  //   hasBadge: true,
  //   sectionTitle: 'Catalogue'
  // },
  // {
  //   id: 'etablishments',
  //   label: 'Mes établissements',
  //   icon: 'building',
  //   url: ROUTES.establishments,
  //   hasBadge: true
  // },
];
